import { AwOptions } from "@/models/AwOptions"

export function callSetup() {
  ;(window as any).setupAmplilyWidget = (options: AwOptions) => {
    const el = document.getElementsByClassName(
      "parmonic-widget"
    )[0] as HTMLElement
    if (!el) {
      console.error("Parmonic Widget Incorrectly set up")
      return
    }
    const layout: string = el.getAttribute("data-layout") ?? "none"
    switch (layout) {
      case "grid":
        ;(window as any).setupAmplilyGrid(options)
        break
      case "list":
        ;(window as any).setupAmplilyList(options)
        break
      case "horizontal":
        ;(window as any).setupAmplilyHorizontal(options)
        break
      case "playlist":
        ;(window as any).setupAmplilyPlaylist(options)
        break
      case "timeline":
        ;(window as any).setupAmplilyTimeline(options)
        break
      case "single":
        ;(window as any).setupAmplilySingle(options)
        break
      case "slider":
        ;(window as any).setupAmplilySlider(options)
        break
      case "none":
        console.error("Parmonic Widget Incorrectly set up")
        break
    }
  }
}
